// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"150":"52a53029","444":"68c86cbb","581":"7fbbd305","699":"a659d675","781":"5781cc92"}[chunkId] + ".chunk.js";
};